import {HttpContext, HttpContextToken} from '@angular/common/http';

/**
 * Status codes that {@link HttpErrorInterceptor} should NOT log to the console
 * for the request carrying this context. Useful for endpoints that legitimately
 * return certain 4xx codes as a normal part of their protocol (e.g. polling
 * /tenants/import returns 403 while approval is pending, 404 once the token is
 * gone — both are expected control flow, not real errors).
 */
export const SUPPRESS_ERROR_LOG_STATUSES =
  new HttpContextToken<readonly number[]>(() => []);

/**
 * Convenience builder so callers don't need to import HttpContext + Token together.
 */
export function suppressErrorLog(...statuses: number[]): HttpContext {
  return new HttpContext().set(SUPPRESS_ERROR_LOG_STATUSES, statuses);
}
